import React from 'react';

import { Telemetry } from '@videoblocks/kafka-rest-client';

import { AUDIO, IMAGE, VIDEO } from '../../common/utils';

interface Props {
  makerEditorLink: string;
  stockItemId: number;
  contentClass: string;
}

const MakerEditorActionsHook = ({
  makerEditorLink,
  stockItemId,
  contentClass,
}: Props) => {
  if (!makerEditorLink) {
    return null;
  }
  return (
    <div className="makerEditorActionsHook hidden lg:block shadow-md border border-solid border-gray-200 relative rounded-l w-full px-6 py-12 my-4">
      <div className="md:text-l lg:text-xl xl:text-2xl 2xl:text-3xl font-bold text-pink-500 mb-10">
        <img
          className="xl:w-32 mx-2"
          src={__ASSETS_COMMON_IMAGES_URL__ + '/icons/maker.svg'}
          alt="Maker"
          width={78}
          height={48}
        />
        <span className="align-bottom ml-4">
          Customize this stock item using Maker, our simple video editor
        </span>
      </div>
      <div className="flex align-content-start text-center text-sm lg:text-base">
        {/*Trim*/}
        {(contentClass === AUDIO || contentClass === VIDEO) && (
          <a
            href={makerEditorLink + '&trimItem=' + stockItemId}
            onClick={() =>
              Telemetry.increment(
                'maker.details.cta.click.test.trim.' + contentClass
              )
            }
            className="w-1/3 mx-4 text-black font-bold transition-colors bg-white hover:bg-black hover:text-white rounded-full py-2 px-10 no-underline border-black border-solid border-2"
          >
            Trim
          </a>
        )}
        {/*Start a Video Project*/}
        {(contentClass === AUDIO || contentClass === IMAGE) && (
          <a
            href={makerEditorLink}
            onClick={() =>
              Telemetry.increment(
                'maker.details.cta.click.test.start.' + contentClass
              )
            }
            className="w-1/3 mx-4 text-black font-bold transition-colors bg-white hover:bg-black hover:text-white rounded-full py-2 px-10 no-underline border-black border-solid border-2"
          >
            Start a video project
          </a>
        )}
        {/*Overlay Text*/}
        {(contentClass === VIDEO || contentClass === IMAGE) && (
          <a
            href={makerEditorLink + '&addText=Add%20Text%20Here'}
            onClick={() =>
              Telemetry.increment(
                'maker.details.cta.click.test.text.' + contentClass
              )
            }
            className="w-1/3 mx-4 text-black font-bold transition-colors bg-white hover:bg-black hover:text-white rounded-full py-2 px-10 no-underline border-black border-solid border-2"
          >
            Overlay text
          </a>
        )}
        {/*Add Your Logo*/}
        {(contentClass === VIDEO || contentClass === IMAGE) && (
          <a
            href={makerEditorLink + '&addLogo=1'}
            onClick={() =>
              Telemetry.increment(
                'maker.details.cta.click.test.logo.' + contentClass
              )
            }
            className="w-1/3 mx-4 text-black font-bold transition-colors bg-white hover:bg-black hover:text-white rounded-full py-2 px-10 no-underline border-black border-solid border-2"
          >
            Add your logo
          </a>
        )}
      </div>
    </div>
  );
};

export default MakerEditorActionsHook;
